import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=214c304c&scoped=true&lang=pug&"
import script from "./MessageText.vue?vue&type=script&lang=js&"
export * from "./MessageText.vue?vue&type=script&lang=js&"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=214c304c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c304c",
  null
  
)

export default component.exports